import { useState, useEffect, React } from "react";
import $ from 'jquery';
// core components
import './Gallery.css';
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import Footer from "../Footer/Footer.js";
import Loader from "../../components/loader/loader.js";
import About from "../../assets/images/about.png"
import Imageone from "../../assets/images/imageone.jpeg"
import Imagetwo from "../../assets/images/Imagetwo.jpeg"
import Imagethree from "../../assets/images/Imagethree.jpeg"
import Imagefour from "../../assets/images/Imagefour.jpeg"
import Imagefive from "../../assets/images/Imagefive.jpeg"
import Imagesix from "../../assets/images/Imagesix.jpeg"
import Imageseven from "../../assets/images/Imageseven.jpeg"
import Imageeight from "../../assets/images/Imageeight.jpeg"
import Imagenine from "../../assets/images/Imagenine.jpeg"
import Imageten from "../../assets/images/Imageten.jpeg"
import Imageeleven from "../../assets/images/Imageeleven.jpeg"
import Imagetweleve from "../../assets/images/Imagetweleve.jpeg"
import Imagethireteen from "../../assets/images/Imagethireteen.jpeg"
import Imagefourteen from "../../assets/images/Imagefourteen.jpeg"
import Imagefiveteen from "../../assets/images/Imagefiveteen.jpeg"
import Imagesixteen from "../../assets/images/Imagesixteen.jpeg"
import Imageseventeen from "../../assets/images/Imageseventeen.jpeg"
import Imageeightteen from "../../assets/images/Imageeightteen.jpeg"
import Imagenineteen from "../../assets/images/Imagenineteen.jpeg"
import Imagetwenty from "../../assets/images/Imagetwenty.jpeg"
import Imagetwentyone from "../../assets/images/Imagetwentyone.jpeg"
import Imagetwentytwo from "../../assets/images/Imagetwentytwo.jpeg"
import Imagetwentythree from "../../assets/images/Imagetwentythree.jpeg"
import Imagetwentyfour from "../../assets/images/Imagetwentyfour.jpeg"
import Imagetwentyfive from "../../assets/images/Imagetwentyfive.jpeg"
import Imagetwentysix from "../../assets/images/Imagetwentysix.jpeg"
import Imagetwentyseven from "../../assets/images/Imagetwentyseven.jpeg"
import Imagetwentyeight from "../../assets/images/Imagetwentyeight.jpeg"
import Imagetwentynine from "../../assets/images/Imagetwentynine.jpeg"
import Imagethirty from "../../assets/images/Imagethirty.jpeg"
import Pongal from "../../assets/videos/pongal.mp4"
import Aramthon from "../../assets/videos/aramthon.mp4"
import Worldseniorcitizen from "../../assets/videos/worldseniorcitizen.mp4"
import Senior from "../../assets/videos/senior.mp4"
import ARMADHAM from "../../assets/videos/ARMADHAM.mp4"
import Chessone from "../../assets/videos/Chessone.mp4"
import Chesstwo from "../../assets/videos/Chesstwo.mp4"
import Chessthree from "../../assets/videos/Chessthree.mp4"
import Imagethirthree from "../../assets/images/Imagethirthree.jpeg"

import One from "../../assets/images/Chess_competition/One.jpg"
import two from "../../assets/images/Chess_competition/two.jpg"
import three from "../../assets/images/Chess_competition/three.jpg"
import four from "../../assets/images/Chess_competition/four.jpg"
import five from "../../assets/images/Chess_competition/five.jpg"
import six from "../../assets/images/Chess_competition/six.jpg"
import seven from "../../assets/images/Chess_competition/seven.jpg"
import eight from "../../assets/images/Chess_competition/eight.jpg"
import nine from "../../assets/images/Chess_competition/nine.jpg"
import ten from "../../assets/images/Chess_competition/ten.jpg"
import eleven from "../../assets/images/Chess_competition/eleven.jpg"
import tweleve from "../../assets/images/Chess_competition/tweleve.jpg"
import thirteen from "../../assets/images/Chess_competition/thirteen.jpg"
import fourteen from "../../assets/images/Chess_competition/fourteen.jpg"
import fifteen from "../../assets/images/Chess_competition/fifteen.jpg"
import sixteen from "../../assets/images/Chess_competition/sixteen.jpg"
import seventeen from "../../assets/images/Chess_competition/seventeen.jpg"
import eighteen from "../../assets/images/Chess_competition/eighteen.jpg"
import nineteen from "../../assets/images/Chess_competition/nineteen.jpg"
import twenty from "../../assets/images/Chess_competition/twenty.jpg"
import twentyone from "../../assets/images/Chess_competition/twentyone.jpg"
import twentytwo from "../../assets/images/Chess_competition/twentytwo.jpg"


import {Link} from "react-router-dom";

export default function Home() {
   const [loading, setLoading] = useState(true);
   const [activeTab, setActiveTab] = useState("tab1");
 
 
   useEffect(() => {
     const timer = setTimeout(() => {
       setLoading(false);
     }, 2500); 
 
     return () => clearTimeout(timer);
   }, []);
   $(window).scroll(function () {
    if ($(this).scrollTop()) {
      $('header').addClass('fixedTop');
    } else {
      $('header').removeClass('fixedTop');
    }
  });
  useEffect(() => {
     window.scrollTo(0, 0)
   }, [])
   
  return (
<div>
{loading ? <Loader /> :
    <div>
        <div className="vision_header Gallery_header">
          <section className="vision_banner">
            <div className="container-fluid custom-container">
               <div className="row">
                  <div className="col-md-6 col-sm-12 col-12">
                     <div className="vision_banner_text">
                        <h1>Gallery</h1>
                       </div>
                  </div>
                  <div className="col-md-6 col-sm-12 col-12">
                     <div className="vision_banner_img">
                     <img src={About} alt="about" className="img-fluid"/>
                     </div>
                  </div>
               </div>
               </div>
            
                  
            </section>
           <section className="gallery mt-4 pt-5">
            <div className="container-fluid custom_container">
                <h2>Gallery</h2>
              
             <div className="gallery_photos">
                
                 <div className="tabs-container">
      <div className="tabs-header">
        <button
          className={activeTab === "tab1" ? "active" : ""}
          onClick={() => setActiveTab("tab1")}
        >
          Pongal 2025 – A Celebration of Light, Love, and Humanity
        </button>
        <button
          className={activeTab === "tab2" ? "active" : ""}
          onClick={() => setActiveTab("tab2")}
        >
          State Level Chess Competition
        </button>
        {/* <button
          className={activeTab === "tab3" ? "active" : ""}
          onClick={() => setActiveTab("tab3")}
        >
          Medical Camp Services
        </button> */}
        <button
          className={activeTab === "tab4" ? "active" : ""}
          onClick={() => setActiveTab("tab4")}
        >
         ARMADHAM '24
        </button>
        <button
          className={activeTab === "tab5" ? "active" : ""}
          onClick={() => setActiveTab("tab5")}
        >
        World Senior Citizen
        </button>
      </div>

      <div className="tabs-content">
        {activeTab === "tab1" && <div className="tab-pane">
          <div class="gallerycontainer">
  <div class="item"><img src={Imageone} alt="Founder" className="img-fluid"/></div>
 
  <div class="item"><img src={Imagetwo} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagethree} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagefour} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagefive} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagesix} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imageseven} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imageeight} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagenine} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imageten} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imageeleven} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagetweleve} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagethireteen} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagefourteen} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagefiveteen} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagesixteen} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imageseventeen} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imageeightteen} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagenineteen} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagetwenty} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagetwentyeight} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagetwentyone} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagetwentytwo} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagetwentythree} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagetwentyfive} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagetwentyfour} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagetwentysix} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagetwentyseven} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagetwentynine} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagethirty} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={Imagethirthree} alt="Founder" className="img-fluid"/></div>
  
   </div>
   <div className="gallery_photos">
               <h2>Videos</h2>
                 
              <div class="videocontainer">
                <div class="item iframe-container"><iframe src={Pongal} frameborder='0'  allow="fullscreen" allowfullscreen title='Jayam Charitable Trust'muted/></div>
                <div class="item"></div>
              </div>
               </div>
          </div>}
        {activeTab === "tab2" && <div className="tab-pane">
          <div class="gallerycontainer">
  <div class="item"><img src={One} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={two} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={three} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={four} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={five} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={six} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={seven} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={eight} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={nine} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={ten} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={eleven} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={tweleve} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={thirteen} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={fourteen} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={fifteen} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={sixteen} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={seventeen} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={eighteen} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={nineteen} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={twenty} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={twentyone} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={twentytwo} alt="Founder" className="img-fluid"/></div>
</div>
<div className="gallery_photos">
               <h2>Videos</h2>
                 
              <div class="videocontainer">
                <div class="item iframe-container"><iframe src={Chessone} frameborder='0'  allow="fullscreen" allowfullscreen title='Jayam Charitable Trust'muted/></div>
                <div class="item iframe-container"><iframe src={Chesstwo} frameborder='0'  allow="fullscreen" allowfullscreen title='Jayam Charitable Trust'muted/></div>
                <div class="item iframe-container"><iframe src={Chessthree} frameborder='0'  allow="fullscreen" allowfullscreen title='Jayam Charitable Trust'muted/></div>
             
              </div>
               </div>
</div>}
        {/* {activeTab === "tab3" && <div className="tab-pane">
          <div class="gallerycontainer">
  <div class="item"><img src={One} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={two} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={three} alt="Founder" className="img-fluid"/></div>
  
</div>
          
          </div>} */}
        {activeTab === "tab4" && <div className="tab-pane">
          
          <div class="gallerycontainer">
  <div class="item"><img src={One} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={two} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={three} alt="Founder" className="img-fluid"/></div>
 
 
 
</div>
 <div className="gallery_photos">
               <h2>Videos</h2>
                 
              <div class="videocontainer">
                <div class="item iframe-container"><iframe src={Aramthon} frameborder='0'  allow="fullscreen" allowfullscreen title='Jayam Charitable Trust'muted/></div>
                <div class="item iframe-container"><iframe src={ARMADHAM} frameborder='0'  allow="fullscreen" allowfullscreen title='Jayam Charitable Trust'muted/></div>
             
              </div>
               </div>
          </div>}
        {activeTab === "tab5" && <div className="tab-pane">
          
          {/* <div class="gallerycontainer">
  <div class="item"><img src={One} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={two} alt="Founder" className="img-fluid"/></div>
  <div class="item"><img src={three} alt="Founder" className="img-fluid"/></div>
 
 
 
</div> */}
 <div className="gallery_photos">
               <h2>Videos</h2>
                 
              <div class="videocontainer">
                <div class="item iframe-container"><iframe src={Worldseniorcitizen} frameborder='0'  allow="fullscreen" allowfullscreen title='Jayam Charitable Trust'muted/></div>
                <div class="item iframe-container"><iframe src={Senior} frameborder='0'  allow="fullscreen" allowfullscreen title='Jayam Charitable Trust'muted/></div>
                 </div>
               </div>
          </div>}
      </div>
    </div>
                 
               </div>
                <div className="container-fluid custom_container_inner">
             
                    
                  </div>
                
                  
              
            </div>         
           </section>
                  
           <Footer />
        </div>
     
    </div>
    }
    </div>
  )
}
